import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Truck } from "lucide-react";
import SecondaryDispatchForm from "./components/SecondaryDispatchForm";

const CreateSecondaryDispatchDialog = ({ open, onOpenChange, parentTripId, onSuccess }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="max-w-[96vw] md:max-w-[850px] lg:max-w-[1050px] max-h-[92vh] overflow-y-auto p-6">
        <DialogHeader className="border-b pb-4 mb-4">
          <DialogTitle className="text-xl font-semibold flex items-center gap-2 text-foreground tracking-tight">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-primary/10 text-primary">
              <Truck className="w-5 h-5" />
            </div>
            Create Secondary Dispatch
          </DialogTitle>
        </DialogHeader>

        {open && parentTripId && (
          <SecondaryDispatchForm
            parentTripId={parentTripId}
            onCancel={() => onOpenChange(false)}
            onSuccess={(result) => {
              if (onSuccess) onSuccess(result);
              onOpenChange(false);
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CreateSecondaryDispatchDialog;
